import { useTranslation } from 'react-i18next';
import { useGetRequiredRule } from '@/hooks';
import { ImportProductsFieldNames } from '../helpers/types';

export const useImportProductsFormRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });

  return {
    [ImportProductsFieldNames.PARTNER_ID]: [requiredRule],
    [ImportProductsFieldNames.CATEGORY_ID]: [requiredRule],
  };
};
